/* eslint-disable max-lines */
/* eslint-disable max-len */
import React from 'react';
import {Form, Grid} from 'semantic-ui-react';
import {floatingStateListSolNac, floatingStateListReserve} from '../../../constants/floatingStateList';
import DatePicker from 'react-datepicker';
import {
  dateFormatPicker,
  noTimeZoneFullISODate,
  reverseShortDate,
} from '../../../../common/constants/datesFormat';
import moment from 'moment';
import {connect} from 'react-redux';
import useStateForm from './customHooks/useStateForm';
import {formValidations} from '../../../constants/formValidations';
import {completeWithCeros} from '../../../utils/commonUtils';
import {solNacDigits} from '../../../constants/commons';
import {businessTypeList} from '../../../constants/businessTypeList';
import {Actions} from '../../../../common/actions';

const StateForm = ({
  data,
  dataError,
  handleChange,
  fetchAdviserList,
  fetchAddDaysToDate,
  isUserTde,
  listDealersDD,
  advisersListDD,
  dealerId,
  loadingAdviser,
  handleInputTextChange,
  isAvailable,
  passedSolNac,
  currentLineOriginal,
  fetchFlInventoryAttachments,
}) => {
  const {
    'actions': {
      handleAdviserSelector,
      handleBusinessTypeChange,
      handleDateChange,
      handleFloatingStateChange,
      handleDealerChange,
    },
    'dataValues': {
      isSolNac,
      mappedReserveAdvance,
    },
  } = useStateForm({
    data,
    handleChange,
    fetchAdviserList,
    fetchFlInventoryAttachments,
  });
  return (
    <>
      <Form size={'small'} className='form-floating-inventory'>
        <div className='w-100 floating-inv-section-title'>
          A. ESTADO DE LA RESERVA
        </div>
        <Grid
          stackable
          fluid
          className='no-space-state-fl w-100'
          textAlign='left'
          columns={2}
        >
          <Grid.Column width={11} columns={4} className='no-space'>
            <Grid className='no-space'>
              <Grid.Row width={16} columns={4} className='no-space'>
                <Grid.Column width={4}>
                  <Form.Select
                    disabled={!isAvailable || passedSolNac}
                    required={isSolNac}
                    className='selector-tiny-size small-label-custom floating-inventory-full-width'
                    label='TIPO DE NEGOCIO'
                    placeholder='SELECCIONAR...'
                    name='businessType'
                    value={data.businessType}
                    options={businessTypeList}
                    error={dataError.businessTypeError}
                    onChange={(e, {name, value}) => handleBusinessTypeChange(name, value, formValidations.businessType(data))
                    }
                    onBlur={(e, {name, value}) =>
                      handleChange(name, value, formValidations.businessType(data))
                    }
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <Form.Select
                    required
                    label='ESTADO'
                    className='selector-tiny-size small-label-custom floating-inventory-full-width'
                    placeholder='SELECCIONAR...'
                    name='floatingState'
                    value={data.floatingState}
                    options={['S', 'L', 'V'].includes(currentLineOriginal.floatingState) ?
                      floatingStateListSolNac : (
                        currentLineOriginal.floatingState === 'R' ?
                          floatingStateListReserve.concat(floatingStateListSolNac) :
                          floatingStateListReserve
                      )
                    }
                    onChange={(e, {name, value}) =>
                      handleFloatingStateChange(
                        name,
                        value,
                        formValidations.floatingState(data)
                      )
                    }
                    onBlur={({'target': {name, value}}) =>
                      handleFloatingStateChange(
                        name,
                        value,
                        formValidations.floatingState(data)
                      )
                    }
                    error={dataError.floatingStateError}
                    disabled={!isUserTde || !isAvailable || passedSolNac}
                  />
                </Grid.Column>
                <Grid.Column width={3}>
                  <Form.Input
                    disabled={!isAvailable}
                    label='N° SOLICITUD DE NAC.:'
                    readOnly
                    className='small-label-custom floating-inventory-full-width floating-inventory-state-mb-1'
                    size='mini'
                    placeholder=' - '
                    name='solNacNumber'
                    value={
                      data.floatingState === 'S' && data.solNacNumber ?
                        completeWithCeros(String(data.solNacNumber), solNacDigits) :
                        ' - '
                    }
                  />
                </Grid.Column>
                <Grid.Column width={5}>
                  <Form.Select
                    disabled={!isAvailable}
                    required={isSolNac}
                    label='AVANCE DE RESERVA'
                    className='selector-tiny-size small-label-custom floating-inventory-full-width'
                    placeholder='SELECCIONAR...'
                    name='reserveAdvance'
                    value={data.reserveAdvance}
                    options={mappedReserveAdvance}
                    onChange={(e, {name, value}) =>
                      handleChange(
                        name,
                        value,
                        formValidations.reserveAdvance(data)
                      )
                    }
                    onBlur={({'target': {name, value}}) =>
                      handleChange(
                        name,
                        value,
                        formValidations.reserveAdvance(data)
                      )
                    }
                    error={dataError.reserveAdvanceError}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row width={16} columns={4} className='no-space-state-fl-col2'>
                <Grid.Column width={4}>
                  <Form.Select
                    required
                    className='selector-tiny-size small-label-custom floating-inventory-full-width'
                    label='DEALER'
                    placeholder='SELECCIONAR...'
                    name='dealerReservation'
                    disabled={!isUserTde || !isAvailable || passedSolNac}
                    value={!isUserTde && isAvailable ? dealerId : data.dealerReservation}
                    options={listDealersDD}
                    error={dataError.dealerReservationError}
                    onChange={(e, {name, value}) => {
                      handleChange(name, value, formValidations.dealerReservation(data));
                      fetchFlInventoryAttachments(`${data.document}/${value}`);
                    }
                    }
                    onBlur={(e, {name, value}) =>
                      handleDealerChange(
                        name,
                        value,
                        formValidations.dealerReservation(data)
                      )
                    }
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <Form.Select
                    className='selector-tiny-size small-label-custom floating-inventory-full-width'
                    loading={loadingAdviser}
                    onClick={handleAdviserSelector}
                    required
                    disabled={advisersListDD === 0 || !isAvailable || passedSolNac}
                    label='ASESOR'
                    placeholder={'SELECCIONAR...'}
                    name='adviserCode'
                    value={data.adviserCode}
                    options={advisersListDD}
                    error={dataError.adviserCodeError}
                    search
                    onChange={(e, {name, value}) =>
                      handleChange(name, value, formValidations.adviserCode(data))
                    }
                    onBlur={(e, {name, value}) =>
                      handleChange(name, value, formValidations.adviserCode(data))
                    }
                  />
                </Grid.Column>
                {data.floatingState === 'S' && (<>
                
                  <Grid.Column width={3}>
                    <DatePicker
                      disabled={!isAvailable}
                      placeholderText='SELECCIONE LA FECHA'
                      showYearDropdown
                      selected={
                        data.informBillDate ?
                          moment(
                            data.informBillDate,
                            noTimeZoneFullISODate
                          ).toDate() :
                          null
                      }
                      dateFormat={dateFormatPicker}
                      customInput={
                        <Form.Input
                          icon='calendar'
                          className='small-label-custom calendar-input-floating floating-inventory-full-width'
                          size='mini'
                          label='FECHA FACTURA INFORMATIVA:'
                          placeholder=' - '
                          error={dataError.informBillDateError}
                        />
                      }
                      onChange={(value) => {
                        handleDateChange('informBillDate', value, formValidations.informBillDate(data));
                        fetchAddDaysToDate(
                          moment(value).format(reverseShortDate),
                          6,
                          handleChange,
                          'estSaleDate'
                        );
                        fetchAddDaysToDate(
                          moment(value).format(reverseShortDate),
                          10,
                          handleChange,
                          'estBillDate'
                        );
                      }}
                      locale='es'
                    />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <DatePicker
                      disabled={!isAvailable}
                      onChange={(value) => {
                        handleDateChange('estSaleDate', value);
                        fetchAddDaysToDate(
                          moment(value).format(reverseShortDate),
                          4,
                          handleChange,
                          'estBillDate'
                        );
                      }}
                      placeholderText='SELECCIONE LA FECHA'
                      showYearDropdown
                      selected={
                        data.estSaleDate ?
                          moment(
                            data.estSaleDate,
                            noTimeZoneFullISODate
                          ).toDate() :
                          null
                      }
                      dateFormat={dateFormatPicker}
                      customInput={
                        <Form.Input
                          icon='calendar'
                          className='small-label-custom calendar-input-floating floating-inventory-full-width'
                          size='mini'
                          label='FECHA ESTIMADA DE LIQUIDACIÓN:'
                          placeholder=' - '
                          error={dataError.estSaleDateError}
                        />
                      }
                      locale='es'
                    />
                  </Grid.Column>
                </>)}
              </Grid.Row>
            </Grid>
          </Grid.Column>
          <Grid.Column width={5} columns={4} className='floating-inventory-state-observations'>
            <Grid.Column width={5}>
              <Form.TextArea
                disabled={!isAvailable}
                label='OBSERVACIONES'
                placeholder=' - '
                className=
                  {'small-label-custom floating-inventory-full-width floating-inventory-state-mb-1'}
                size='mini'
                name='observations'
                error={dataError.observationsError}
                value={data.observations}
                onChange={(e, {name, value}) => handleInputTextChange(
                  e,
                  {name, value},
                  formValidations.observations(data),
                )}
                onBlur={({'target': {name, value}}) =>
                  handleChange(name, value, formValidations.observations(data))
                }
                style={{'height': '100%', 'resize': 'none'}}
              />
            </Grid.Column>
          </Grid.Column>
        </Grid>
      </Form>
    </>
  );
};

const {fetchAdviserList, fetchAddDaysToDate, fetchFlInventoryAttachments} = Actions;
const mapStateToProps = (state) => {
  return {
    'listDealers': state.dealer.list,
    'isUserTde': state.session.isUserFromTDE,
    'dealerId': state.session.dealerId,
    'loadingAdviser': state.floatingInventory.loadingAdviser,
  };
};

export default connect(mapStateToProps, {fetchAdviserList, fetchAddDaysToDate, fetchFlInventoryAttachments})(StateForm);
